const stats = [
  {
    value: 7,
    title: 'Years in Business',
  },

  {
    value: 400,
    title: 'Project Completed',
  },

  {
    value: 250,
    title: 'Happy Clients',
  },
]
type StatProps = {
  value: number
  title: string
}
const Stat = ({ value, title }: StatProps) => {
  return (
    <div className="flex flex-col items-center justify-center text-center font-inter [font-weight:500]">
      <span className="text-[36px]  leading-[43.57px] text-[#D4AF37] ">
        {value}+
      </span>
      <span className="text-[9px] leading-[24px] text-[#333333] md:text-nowrap  md:text-[11px] lg:text-[16px] lg:leading-[24px]">
        {title}
      </span>
    </div>
  )
}

export const Stats = () => {
  return (
    <>
      {stats.map((stat, index) => (
        <Stat key={index} {...stat} />
      ))}
    </>
  )
}
